import { render, staticRenderFns } from "./CreateVulnerability.vue?vue&type=template&id=156c3961&"
import script from "./CreateVulnerability.vue?vue&type=script&lang=js&"
export * from "./CreateVulnerability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports